const defaultHasuraUri = 'https://vrplatform-hasura.fly.dev/v1/graphql'; // 'https://eu.hasura.vrplatform.app/v1/graphql';
const location = typeof window === 'undefined' ? undefined : window.location;
const locationHost = location?.host ?? '';
const locationHostname = location?.hostname ?? '';
const locationHref = location?.href ?? '';

export const GRAPHQL_URI = `${
  import.meta.env.VITE_GRAPHQL_URI || defaultHasuraUri
}`;

export const AUTH_REDIRECT_URL = import.meta.env.DEV
  ? 'https://tolocalhost.com/verification'
  : `https://${locationHost || 'portal.vrplatform.app'}/verification`;

export const NEW_SIGN_IN = false;

type Platform = 'finalytic' | 'vrplatform';

export const PLATFORM: Platform =
  (import.meta.env.VITE_PLATFORM_NAME as Platform) || 'vrplatform';

// Google Maps api key

export const STATUS_PAGE =
  PLATFORM === 'finalytic'
    ? 'https://status.finalytic.io'
    : 'https://status.vrplatform.app';

export const isLocalhost =
  locationHost.includes('localhost') || locationHost.includes('127.0.0.1');
export const isStaging = locationHostname === 'staging.portal.vrplatform.app';
export const isProduction = locationHostname === 'portal.vrplatform.app';
export const isExtension = locationHref.startsWith('chrome-extension');
export const isStorybook = import.meta.env.VITE_STORYBOOK === 'true';
